import React from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { store } from "../reducer/Store";
import SelectBrands from "./SelectBrands";
import FormPasswordRegisterOrUpdate from "./FormPasswordRegisterOrUpdate";
import PasswordShowHide from "./PasswordShowHide";
const FormRegisterUpdate = ({
  controlFormId,
  registerOrUpdateUser,
  id,
  name,
  email,
  currentPwd,
  pwd,
  pwdConfirm,
  role,
  brand,
  setName,
  setCurrentPwd,
  setPwd,
  setPwdConfirm,
  setBrand,
  setRole,
  setEmail,
  handleClose,
  errorMail,
  errorPassword,
  show,
  getNameRole,
}) => {
  const { state } = React.useContext(store);
  const [passwordShow, setPasswordShow] = React.useState(false);
  const handlePasswordShow = () => setPasswordShow(!passwordShow);
  const [formData] = React.useState({
    name: name || "",
    email: email || "",
    currentPwd: "",
    pwd: "",
    pwdConfirm: "",
    role: role || "",
    brands: brand || [],
  });
  const [newFormData, setNewFormData] = React.useState({
    ...formData,
  });
  const handleInputChange = (e, name = "") => {
    if (name === "brands") {
      setNewFormData({
        ...newFormData,
        brands: e,
      });
    } else if (e.target.name === "role") {
      setNewFormData({
        ...newFormData,
        [e.target.name]: !isNaN(parseInt(e.target.value))
          ? parseInt(e.target.value)
          : "",
      });
    } else {
      setNewFormData({
        ...newFormData,
        [e.target.name]: e.target.value,
      });
    }
  };
  const handleModalHide = () => {
    var windowConfirm = false;
    if (JSON.stringify(formData) !== JSON.stringify(newFormData)) {
      windowConfirm = true;
    }
    if (windowConfirm) {
      if (
        window.confirm(
          "Vous avez effectué des changements, êtes vous sûr de vouloir quitter sans valider ?"
        )
      ) {
        handleClose();
      }
    } else {
      handleClose();
    }
  };
  return (
    <Modal show={show} size="lg" onHide={() => handleModalHide()} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {controlFormId.includes("register")
            ? "Ajouter un utilisateur"
            : controlFormId === "update-password-header"
            ? "Modifier mon mot de passe"
            : `Modifier : ${state.users.filter((e) => e.id === id)[0].name}_
            ${getNameRole(state.users.filter((e) => e.id === id)[0].role)}`}
        </Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={(e) => {
          setPasswordShow(false);
          registerOrUpdateUser(e);
        }}
      >
        <Modal.Body>
          {controlFormId.includes("update-password") ? (
            <div className="col-md-12">
              <>
                {controlFormId === "update-password-header" && (
                  <Form.Group
                    className="mb-3"
                    controlId={`new-password-${controlFormId}`}
                  >
                    <Form.Label>Mot de passe actuel</Form.Label>
                    <Form.Group className="row">
                      <div className="col-md-10 pe-0">
                        <Form.Control
                          type={passwordShow ? "text" : "password"}
                          placeholder="Password actuel"
                          required
                          name="currentPwd"
                          autoComplete="new-password-current"
                          className="passwordHide"
                          title="Le mot de passe doit contenir au moins 8 caractères, un lettre majuscule, un une lettre miniscule, 
            un chiffre, un caractère spécial(#?!@$%^&*-)."
                          pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$"
                          value={currentPwd}
                          onChange={(e) => {
                            handleInputChange(e);
                            setCurrentPwd(e.target.value);
                          }}
                        />
                      </div>
                      <PasswordShowHide
                        handlePasswordShow={handlePasswordShow}
                        passwordShow={passwordShow}
                      />
                    </Form.Group>
                  </Form.Group>
                )}
              </>
              <FormPasswordRegisterOrUpdate
                passwordShow={passwordShow}
                controlFormId={controlFormId}
                pwd={pwd}
                setPwd={setPwd}
                handlePasswordShow={handlePasswordShow}
                errorPassword={errorPassword}
                setPwdConfirm={setPwdConfirm}
                pwdConfirm={pwdConfirm}
                handleInputChange={handleInputChange}
              />
            </div>
          ) : (
            <div className="row">
              <div className="col-md-6">
                <Form.Group
                  className="mb-3"
                  controlId={`new-name-${controlFormId}`}
                >
                  <Form.Label>Prénom Nom</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Nom"
                    autoFocus
                    required
                    value={name}
                    name="name"
                    onChange={(e) => {
                      handleInputChange(e);
                      setName(e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId={`new-email-${controlFormId}`}
                >
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Email"
                    //pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                    autoComplete={`new-email-${controlFormId}`}
                    title="ex : utilisateur@gmail.com"
                    required
                    value={email}
                    name="email"
                    onChange={(e) => {
                      handleInputChange(e);
                      setEmail(e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Text className="text-danger">{errorMail}</Form.Text>
                </Form.Group>
                {controlFormId === "register" && (
                  <FormPasswordRegisterOrUpdate
                    passwordShow={passwordShow}
                    controlFormId={controlFormId}
                    pwd={pwd}
                    setPwd={setPwd}
                    handlePasswordShow={handlePasswordShow}
                    errorPassword={errorPassword}
                    setPwdConfirm={setPwdConfirm}
                    pwdConfirm={pwdConfirm}
                    handleInputChange={handleInputChange}
                  />
                )}
              </div>
              <div className="col-md-6">
                <Form.Group
                  className="mb-3"
                  controlId={`new-role-${controlFormId}`}
                >
                  <Form.Label>Rôles</Form.Label>
                  <Form.Select
                    required
                    disabled={role.id === 6}
                    value={role}
                    name="role"
                    onChange={(e) => {
                      handleInputChange(e);
                      setRole(e.target.value);
                    }}
                  >
                    <option value="">Sélectionnez un rôle</option>
                    {state.listUserRoles.map((role) =>
                      role.id !== 1 && role.id !== 6 ? (
                        <option key={role.id} value={role.id}>
                          {role.name}
                        </option>
                      ) : (
                        ""
                      )
                    )}
                  </Form.Select>
                </Form.Group>
                {parseInt(role) === 5 && (
                  <Form.Group
                    className="mb-3"
                    controlId={`new-brand-${controlFormId}`}
                  >
                    <Form.Label>Marque à associé au Lecteur(DV, DR)</Form.Label>
                    <SelectBrands
                      brand={brand}
                      setBrand={setBrand}
                      isRequired={true}
                      handleInputChange={handleInputChange}
                      isFromFormUser={true}
                    />
                  </Form.Group>
                )}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="is-bottom-right">
          <Button
            variant="secondary"
            onClick={() => {
              setPasswordShow(false);
              handleClose();
            }}
          >
            Annuler
          </Button>
          <Button variant="success" type="submit">
            {controlFormId === "register" ? "Ajouter utilisateur" : "Valider"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default FormRegisterUpdate;
